module.exports = "<span class=\"fas fa-{{value ? 'check' : 'times'}} {{inactive ? 'inactive-red' : ''}}\" aria-hidden=\"true\"></span>\n"